// Copyright (c) 2017 Deere & Company

import actions from '../../action-list';

export const resetAllFacets = facets => ({
    dealerAccounts: facets.dealerAccountsFacet.allowedDealers,
    type: actions.RESET_DEALER_INVOICE_FILTERS
});

export const selectAllDealersOnInitialLoad = allowedDealers => ({
    allowedDealers,
    type: actions.SELECT_DEALER_INVOICE_DEALER_ACCOUNT_FACET_ITEMS
});

export const toggleDealerAccountFacetItems = allowedDealers => ({
    allowedDealers,
    type: actions.TOGGLE_DEALER_INVOICE_DEALER_ACCOUNT_FACET_ITEMS
});

export const updateDealerAccountFacetInput = value => ({
    type: actions.UPDATE_DEALER_INVOICE_DEALER_ACCOUNT_FACET_INPUT,
    value
});

export const updateDealerAccountFacetItem = (dealerAccount, isSelected) => ({
    dealerAccount,
    isSelected,
    type: actions.UPDATE_DEALER_INVOICE_DEALER_ACCOUNT_FACET_ITEM
});



// WEBPACK FOOTER //
// ./src/claim/dealer-invoices/action-creators/facets.js